/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AnalysisRemarksSearchResponseDto } from '../models';
// @ts-ignore
import type { AnalysisRemarksSortByDto } from '../models';
// @ts-ignore
import type { SearchAnalysisRemarksRequestDto } from '../models';
// @ts-ignore
import type { SortDirectionDto } from '../models';
/**
 * AnalysisRemarksSearchRestApi - axios parameter creator
 */
export const AnalysisRemarksSearchRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Search analysis remarks with pagination
         * @param {number} pageSize 
         * @param {number} page 
         * @param {SearchAnalysisRemarksRequestDto} searchAnalysisRemarksRequestDto Search analysis remarks
         * @param {SortDirectionDto} [sortOrder] 
         * @param {AnalysisRemarksSortByDto} [sortBy] 
         * @param {string} [processId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAnalysisRemarks: async (pageSize: number, page: number, searchAnalysisRemarksRequestDto: SearchAnalysisRemarksRequestDto, sortOrder?: SortDirectionDto, sortBy?: AnalysisRemarksSortByDto, processId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchAnalysisRemarks', 'pageSize', pageSize)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchAnalysisRemarks', 'page', page)
            // verify required parameter 'searchAnalysisRemarksRequestDto' is not null or undefined
            assertParamExists('searchAnalysisRemarks', 'searchAnalysisRemarksRequestDto', searchAnalysisRemarksRequestDto)
            const localVarPath = `/api/v1/analysis-remarks/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (processId !== undefined) {
                localVarQueryParameter['processId'] = processId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchAnalysisRemarksRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnalysisRemarksSearchRestApi - functional programming interface
 */
export const AnalysisRemarksSearchRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnalysisRemarksSearchRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Search analysis remarks with pagination
         * @param {number} pageSize 
         * @param {number} page 
         * @param {SearchAnalysisRemarksRequestDto} searchAnalysisRemarksRequestDto Search analysis remarks
         * @param {SortDirectionDto} [sortOrder] 
         * @param {AnalysisRemarksSortByDto} [sortBy] 
         * @param {string} [processId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAnalysisRemarks(pageSize: number, page: number, searchAnalysisRemarksRequestDto: SearchAnalysisRemarksRequestDto, sortOrder?: SortDirectionDto, sortBy?: AnalysisRemarksSortByDto, processId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalysisRemarksSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAnalysisRemarks(pageSize, page, searchAnalysisRemarksRequestDto, sortOrder, sortBy, processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisRemarksSearchRestApi.searchAnalysisRemarks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnalysisRemarksSearchRestApi - factory interface
 */
export const AnalysisRemarksSearchRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnalysisRemarksSearchRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Search analysis remarks with pagination
         * @param {number} pageSize 
         * @param {number} page 
         * @param {SearchAnalysisRemarksRequestDto} searchAnalysisRemarksRequestDto Search analysis remarks
         * @param {SortDirectionDto} [sortOrder] 
         * @param {AnalysisRemarksSortByDto} [sortBy] 
         * @param {string} [processId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAnalysisRemarks(pageSize: number, page: number, searchAnalysisRemarksRequestDto: SearchAnalysisRemarksRequestDto, sortOrder?: SortDirectionDto, sortBy?: AnalysisRemarksSortByDto, processId?: string, options?: RawAxiosRequestConfig): AxiosPromise<AnalysisRemarksSearchResponseDto> {
            return localVarFp.searchAnalysisRemarks(pageSize, page, searchAnalysisRemarksRequestDto, sortOrder, sortBy, processId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnalysisRemarksSearchRestApi - interface
 */
export interface AnalysisRemarksSearchRestApiInterface {
    /**
     * 
     * @summary Search analysis remarks with pagination
     * @param {number} pageSize 
     * @param {number} page 
     * @param {SearchAnalysisRemarksRequestDto} searchAnalysisRemarksRequestDto Search analysis remarks
     * @param {SortDirectionDto} [sortOrder] 
     * @param {AnalysisRemarksSortByDto} [sortBy] 
     * @param {string} [processId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAnalysisRemarks(pageSize: number, page: number, searchAnalysisRemarksRequestDto: SearchAnalysisRemarksRequestDto, sortOrder?: SortDirectionDto, sortBy?: AnalysisRemarksSortByDto, processId?: string, options?: RawAxiosRequestConfig): AxiosPromise<AnalysisRemarksSearchResponseDto>;

}

/**
 * AnalysisRemarksSearchRestApi - object-oriented interface
 */
export class AnalysisRemarksSearchRestApi extends BaseAPI implements AnalysisRemarksSearchRestApiInterface {
    /**
     * 
     * @summary Search analysis remarks with pagination
     * @param {number} pageSize 
     * @param {number} page 
     * @param {SearchAnalysisRemarksRequestDto} searchAnalysisRemarksRequestDto Search analysis remarks
     * @param {SortDirectionDto} [sortOrder] 
     * @param {AnalysisRemarksSortByDto} [sortBy] 
     * @param {string} [processId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchAnalysisRemarks(pageSize: number, page: number, searchAnalysisRemarksRequestDto: SearchAnalysisRemarksRequestDto, sortOrder?: SortDirectionDto, sortBy?: AnalysisRemarksSortByDto, processId?: string, options?: RawAxiosRequestConfig) {
        return AnalysisRemarksSearchRestApiFp(this.configuration).searchAnalysisRemarks(pageSize, page, searchAnalysisRemarksRequestDto, sortOrder, sortBy, processId, options).then((request) => request(this.axios, this.basePath));
    }
}

